import { Either, left, right } from 'fp-ts/Either';
import { ProductFieldType } from '../generated/types';
import { isValidDate } from './is-valid-date';
import { isValidNumber } from './is-valid-number';
import { toDisplayCurrency } from './to-display-currency';
import { toDisplayDate } from './to-display-date';

export function resolveChoiceField(
  path: string | null | undefined,
  fallback: string | null | undefined,
  type: ProductFieldType,
  context: Record<string, string>,
  config: Record<string, string>,
  form: Record<string, string>
): Either<Error, string> {
  if (
    (typeof path !== 'string' || path.length === 0) &&
    (typeof fallback !== 'string' || fallback.length === 0)
  ) {
    return left(
      new Error(
        'Both path and fallback are missing, at least one need to be specified'
      )
    );
  }

  let value: string | undefined = undefined;

  if (typeof path !== 'string' || path.length === 0) {
    value = fallback as string;
  } else {
    if (path.startsWith('form.')) {
      value = form[path.substr('form.'.length)];
    } else if (path.startsWith('config.')) {
      value = config[path.substr('config.'.length)];
    } else {
      value = context[path];
    }

    if (typeof value === 'number') {
      value = (value as number).toString();
    }

    if (
      (typeof value !== 'string' || value.length === 0) &&
      typeof fallback === 'string' &&
      fallback.length > 0
    ) {
      value = fallback;
    }
  }

  if (typeof value !== 'string' || value.length === 0) {
    return left(new Error('Could not resolve path'));
  }

  switch (type) {
    case ProductFieldType.Currency: {
      if (isValidNumber(value)) {
        return right(toDisplayCurrency(Number(value), 'EUR'));
      }

      break;
    }
    case ProductFieldType.Date: {
      if (isValidDate(value)) {
        return right(toDisplayDate(value));
      }

      break;
    }
  }

  return right(value);
}
